module.exports = __webpack_public_path__ + "static/media/stethophyma_grossum_002_APA.e1a4f63f.png";